import axios from 'axios';
import { API_BASE_URL } from '../config';
import { acquireAccessToken } from '../helpers/AccessToken';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Cache-Control': 'no-cache' },
});

apiClient.interceptors.request.use(async (config) => {
  if (config.skipAuth || config.headers?.Authorization) return config;

  const token = await acquireAccessToken();
  if (!token) throw new Error('La sesión ha expirado. Inicia sesión de nuevo.');

  config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default apiClient;
